module.exports = __webpack_public_path__ + "static/crowd-8a169778402b979bafabd388d709adf0.png";